import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

export default function RiskDisclosureOnDerivatives() {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white border-b border-gray-300">
        <div className="pr-4 sm:pr-6 lg:pr-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/">
                <img src="/logo.jpg" alt="Anand Rathi Logo" className="h-16 sm:h-20" />
              </Link>
            </div>

            <nav className="hidden md:flex space-x-4 lg:space-x-8 text-gray-800 font-semibold text-sm lg:text-base">
              <div className="relative">
                <button
                  onClick={() => toggleDropdown('group')}
                  className="flex items-center hover:text-yellow-700 transition"
                >
                  GROUP <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {dropdownOpen.group && (
                  <div className="absolute top-full left-0 mt-1 w-48 bg-white shadow-lg border rounded-md z-50">
                    <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">About</Link>
                    <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Leadership</Link>
                  </div>
                )}
              </div>
              <Link to="/contact" className="hover:text-yellow-700 transition">CONTACT US</Link>
            </nav>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="space-y-2">
                <div>
                  <button
                    onClick={() => toggleDropdown('groupMobile')}
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    GROUP <ChevronDown className="h-4 w-4" />
                  </button>
                  {dropdownOpen.groupMobile && (
                    <div className="pl-4 space-y-1">
                      <Link to="/about" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">About</Link>
                      <Link to="/leadership" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Leadership</Link>
                    </div>
                  )}
                </div>
                <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CONTACT US</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-normal text-gray-700 mb-8">Risk Disclosure on Derivatives</h1>

        <div className="space-y-12">
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <h2 className="text-xl font-semibold text-gray-800">RISK DISCLOSURES ON DERIVATIVES</h2>

            <ol className="list-decimal list-inside space-y-4">
              <li>9 out of 10 individual traders in equity Futures and Options Segment, incurred net losses.</li>
              <li>On an average, loss makers registered net trading loss close to Rs. 50,000.</li>
              <li>Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.</li>
              <li>Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.</li>
            </ol>

            <p className="mt-4"><span className="font-semibold">Source:</span></p>
            <p>SEBI study dated January 25, 2023 on "Analysis of Profit and Loss of Individual Traders dealing in equity Futures and Options (F&amp;O) Segment", wherein Aggregate Level findings are based on annual Profit/Loss incurred by individual traders in equity F&amp;O during FY 2021-22.</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-[#3a4a22] to-[#5a6a3a] text-white">
        <div className="container mx-auto px-4 py-8">
          <div className="grid md:grid-cols-4 gap-8 mb-6">
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">REGISTERED OFFICE:</h4>
                <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans">
                  1003 to 1012, 10th Floor, <br />
                  Dalal Street Commercial Cooperative Society Ltd.<br />
                  Block 53E, Zone-5, Road-5E, Gift City,<br />
                  District - Gandhinagar, Gujarat - 382355
                </p>
                <p className="text-sm text-[#D4C4A8] leading-relaxed font-sans mt-2">
                  Contact No. 022 6281 7003
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">QUICK LINKS</h4>
                <div className="space-y-2 text-sm font-sans">
                  <Link to="/kyc-vernacular-language" className="block text-[#D4C4A8] hover:text-white transition">KYC Vernacular Language</Link>
                  <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">ODR Portal</a>
                  <a href="https://eservices.nsdl.com" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">NSDL E-Voting</a>
                  <a href="https://evoting.cdslindia.com/Evoting/EvotingLogin" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CDSL E-Voting</a>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">OTHER LINKS</h4>
                <div className="space-y-2 text-sm font-sans">
                  <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Companies and Associate Details</a>
                  <a href="#" className="block text-[#D4C4A8] hover:text-white transition">Company Profile</a>
                  <Link to="/client-bank-details" className="block text-[#D4C4A8] hover:text-white transition">Client Bank Details</Link>
                  <Link to="/advisory-on-impersonation" className="block text-[#D4C4A8] hover:text-white transition">Advisory on Impersonation</Link>
                  <Link to="/advisory-for-investors" className="block text-[#D4C4A8] hover:text-white transition">Advisory for Investors</Link>
                  <Link to="/investor-complaints" className="block text-[#D4C4A8] hover:text-white transition">Complaints</Link>
                  <Link to="/risk-disclosure-on-derivatives" className="block text-[#D4C4A8] hover:text-white transition">Risk Disclosure on Derivatives</Link>
                  <a href="/PDF/UPI-Handle.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Transfer of funds via SEBI-validated UPI ID</a>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="w-1 bg-white mr-4"></div>
              <div>
                <h4 className="text-white font-bold mb-4 font-sans">DOWNLOADS</h4>
                <div className="space-y-2 text-sm font-sans">
                                                                              <a href="/ARGIL-CRF-Form.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">CRF Form</a>
                                                                              <a href="/Investor-Charter.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Investor Charter</a>
                                                                              <a href="/PDF/RMS-Policy_merged.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">RMS Policy</a>
                                                                              <Link to="/privacy-policy" className="block text-[#D4C4A8] hover:text-white transition">Privacy Policy</Link>
                                                                              <a href="/PDF/Surveillance-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Surveillance Policy</a>
                                                                              <a href="/PDF/new-Client-Code-Modification-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Client Code Modification Policy</a>
                                                                              <a href="/PDF/new-PMLA-Policy.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">AML Policy</a>
                                                                              <a href="/PDF/Policy-regarding-pre-funded-instruments.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy Regarding Pre-Funded Instruments</a>
                                                                              <a href="/PDF/Policy-for-treatment-of-inactive-accounts.pdf" target="_blank" rel="noopener noreferrer" className="block text-[#D4C4A8] hover:text-white transition">Policy for Treatment of Inactive Accounts</a>
                                                                            </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-b from-gray-700 to-gray-800 py-6">
          <div className="container mx-auto px-4">
            <div className="space-y-4 text-xs text-gray-300 font-sans">
              <div>
                <p className="font-semibold text-white mb-2">Anand Rathi Global Intermediaries Ltd.</p>
                <p>CIN : U66120GJ2024PLC148630</p>
                <p>SEBI Registration No.: INZ000327038 (NSE- 90408)</p>
              </div>

              <div>
                <p className="font-semibold text-white mb-2">Disclaimer:</p>
                <div className="space-y-2 leading-relaxed">
                  <p>
                    Equity: Investment in securities market are subject to market risks, read all the related documents carefully before investing.
                    The securities are quoted as an example and not as a recommendation.
                  </p>
                  <p>
                    Mutual Funds: Mutual fund investments are subject to market risks, read all scheme related documents carefully before investing.
                  </p>
                  <p>
                    Certification/Registration granted by SEBI and certification from NISM is in no way a guarantee of performance of the intermediary or provides any assurance of returns to investors.
                  </p>
                </div>
              </div>

              <div>
                <p className="font-semibold text-white mb-3">Attention Investors:</p>
                <ul className="space-y-1 leading-relaxed">
                  <li>• For all communication related to vulnerability reporting, security alerts, or any other suspicious activity related to cyber security, contact argil@rathi.com</li>
                  <li>• For any complaints email at <a href="mailto:argilgrievance@rathi.com" className="text-yellow-400 hover:text-yellow-300">argilgrievance@rathi.com</a></li>
                  <li>• Filing of complaints on <a className="text-yellow-400 hover:text-yellow-300" href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer">SCORES portal</a> – Easy & quick a. Register on SCORES portal b. Mandatory details for filing complaints on SCORES: I. Name, PAN, Address, Mobile Number, Email ID c. Benefits: I. Effective communication ii. Speedy redressal of the grievances.</li>
                  <li>• Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 1, 2020. </li>
                  <li>• Update your mobile number & email Id with your stock broker / depository participant and receive OTP directly from depository</li>
                  <li>• Pay 20% upfront margin of the transaction value to trade in cash market segment</li>
                  <li>• Check your Securities /MF/ Bonds in the consolidated account statement issued by NSDL/CDSL every month</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
